// Traduce un hazard_type típico de puesto (iper_hazard_catalog) a un permit_type/training_type sugerido.
// Los riesgos sin equivalente claro (ej. excavación, LOTO) se ignoran a propósito.
// Compartido entre TrainingsPage.tsx y WorkPermitsPage.tsx (antes duplicado literal en ambos).
export type HazardMappedType = 'altura' | 'confinado' | 'electrico' | 'caliente' | 'vias' | 'maquinaria';

export const HAZARD_TO_PERMIT_TYPE: Record<string, HazardMappedType> = {
  'Trabajo en alturas':                                   'altura',
  'Espacios confinados':                                  'confinado',
  'Eléctrico (alta y baja tensión, estática)':             'electrico',
  'Tecnológico (explosión, fuga, derrame, incendio)':      'caliente',
  'Accidentes de tránsito':                               'vias',
  'Mecánico (elementos o partes de máquinas, herramientas, equipos, piezas a trabajar, materiales proyectados sólidos o fluidos)': 'maquinaria',
};
